class Modify_Date {
    static path = 'modifiers/modify-date';

    constructor(mutator){
        this.bgcolor = '#ea93f8';
        this.title = 'Modify Date';
        this.desc = 'Perform simple adjustments to a date';
        this.values = ["+", "-", "x", "÷", "^", "%"];
        this.properties = {operation: 'Add', unit: 'Days'}

        this.addInput("Date", "date,datetime");
        this.addInput("Modifier (X)", "number");
        this.addOutput("New Date", "date,datetime");
        this.addWidget("combo","",'',{ property: "operation", values: ['Add', 'Subtract'] } );
        this.addWidget("combo","",'',{ property: "unit", values: ['Years', 'Months', 'Days', 'Hours', 'Minutes'] } );
    }

    getTitle() {
        return this.properties.operation + " X " + this.properties.unit;
    }

}

module.exports = Modify_Date
